export default () => ({
  headerLogo: {
    height: 26,
    width: 26,
  },

  headerTile: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 50,
    height: 50,
    backgroundImage: 'linear-gradient(134deg, #FFFFFF 0%, #FAFBFC 100%)',
    border: '1px solid #E1E9F0',
    borderRadius: 6,
    marginRight: 15,
    marginTop: -2,
    background: 'red',
  },
});
